import { useCallback, useRef } from 'react';

/**
 * 
 * @param {Function<t>} initialFunction 
 * @param {Array} deps 
 * @param {number} time 
 * @param {boolean} immediate 
 * @returns {Function<T>}
 */
const useDebounce = (
    initialFunction = () => {},
    deps = [],
    time = 1,
    immediate = false
) => {

    
    
    const timeout = useRef(null)

    const executedFunction = useCallback(function () {

        const context = this
        const args = arguments

        const later = function() {
            timeout.current = null

            if(!immediate)
                initialFunction.apply(context, args)
        }

        let callNow = (immediate && !timeout.current)

        clearTimeout(timeout.current)

        timeout.current = setTimeout(later, time * 1000)

        if(callNow)
            initialFunction.apply(context, args)

    
    // eslint-disable-next-line
    }, [initialFunction, time, immediate, ...deps])


    return executedFunction

};

export default useDebounce;